var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticClass:"filter-item",style:({ width: _vm.widthStyle }),attrs:{"placeholder":"请选择分类","props":_vm.rolesProps,"options":_vm.roleOptionList,"clearable":""},on:{"change":_vm.categoryChange},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})
}
var staticRenderFns = []

export { render, staticRenderFns }